import { Component, OnInit, Injectable, Inject, HostListener } from '@angular/core';
import { DatosBusqueda } from '../../../model/DatosBusqueda';
import { HttpModule } from '@angular/http';
// import { BuscarService } from '../../../services/buscar.service';
import { Router, ActivatedRoute, Params, RoutesRecognized } from '@angular/router';
import { DOCUMENT } from '@angular/platform-browser';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/min';
import * as $ from 'jquery';

import { MenuService } from '../../../services/menu.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  menus:any= [];
  subMenus:any= [];
  menuGeneral:any= [];
  primerMenu:any;
  segundoMenu:any = "";
  constructor(private route: ActivatedRoute,
              private router: Router,
              private menu:MenuService) {
                }

    /*Vinculación al PREP*/
    // goPREP() {
    //   window.open("https://p2018.ine.mx/#/presidencia/nacional/1/1/1/1", "_blank");
    // }

    /*Vinculación al INE*/
    goINE() {
      window.open("http://www.ine.mx/", "_blank");
    }
    ngOnInit():void{
      this.router.events.subscribe(val => {
           if (val instanceof RoutesRecognized ) {
               this.primerMenu = val.state.root.firstChild.url[0].path;
               if(val.state.root.firstChild.url.length > 1){
                 this.segundoMenu = val.state.root.firstChild.url[1].path;
               }
               this.getCortes();
           }
       });

       // menu sticky
       $(window).scroll(function (e) {
         if ($(this).scrollTop() > 100) {
           $("#navbarNavDropdown").addClass("mt-20");
           $("header").css("position", "fixed");
           $(".header-logos").hide();
         } else {
           $(".header-logos").show();
           $("header").css("position", "relative");
           $("#navbarNavDropdown").removeClass("mt-20");
         }
       });

       // Funcion oprimir boton
       function BtnMenu() {
         if ($("#BtnMenu").hasClass("collapsed")) {
           $("#TacheMenu").closest('div').show();
           $("#bloqueado").addClass("bloqueado");
         }
         else {
           $('.c-b').css("border", "1px solid #fff");
           $("#TacheMenu").closest('div').hide();
           $("#bloqueado").removeClass("bloqueado");
         }
       }
       // quitar y poner x
       $("#BtnMenu").click(function () {
         // $('.c-b').css("border", "0px");
         BtnMenu();
       });
       // quitar y poner x
       $("#TacheMenu").click(function () {
         $("#BtnMenu").click();
         $("#bloqueado").removeClass("bloqueado");
         $('.c-b').css("border", "1px solid #fff");
       });
       //cerrar menu desde dropdown-item
       $(".dropdown-item").click(function () {
         console.log("arriba")
         $("#BtnMenu").click();
         $('html,body').animate({scrollTop:'0px'}, 500);
         return false;
       });

       $("#navegacion").click(function(){
           $("#BtnMenu").click();
           $('html,body').animate({scrollTop:'0px'}, 500);
           return false;
       });

    }

    getCortes(){
      this.menuGeneral=[];
      this.menu.getmenu()
      .subscribe(data=>{
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
              this.menuGeneral.push(data[key])
            }
        }
        this.menus=data[this.primerMenu];
      },error=>{
        console.log(error)
      })
    }

    navegar(posicion){
      if(this.menuGeneral[posicion].hasOwnProperty('subMenu')){
        this.router.navigate([''+this.menuGeneral[posicion].url+''+this.menuGeneral[posicion].subMenu[0].subUrl])
      }else{
        this.router.navigate([''+this.menuGeneral[posicion].url])
      }
    }

    ocultarSub():boolean{
      if(this.primerMenu=="Glosario" || this.primerMenu=="Preguntas-Frecuentes"){
        return false;
      }else{
        return true;
      }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/shared/header/header.component.ts